import { g as F, d as b, _ as u, a as E, b as K, P as r, r as G, l as L } from "./createTheme-6e68f5ca.js";
import * as m from "react";
import { g as U, s as M, B as oo, r as no, q as ro, u as q, c as _, a as A, b as eo, o as io } from "./Search-4d6031ad.js";
import { jsx as R, jsxs as to } from "react/jsx-runtime";
import { r as ao } from "./Grid2-9c5e91ab.js";
function so(o) {
  return F("MuiButton", o);
}
const co = U("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), W = co, Z = /* @__PURE__ */ m.createContext({});
process.env.NODE_ENV !== "production" && (Z.displayName = "ButtonGroupContext");
const lo = Z, H = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (H.displayName = "ButtonGroupButtonContext");
const po = H, uo = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], fo = (o) => {
  const {
    color: n,
    disableElevation: e,
    fullWidth: t,
    size: i,
    variant: a,
    classes: s
  } = o, p = {
    root: ["root", a, `${a}${b(n)}`, `size${b(i)}`, `${a}Size${b(i)}`, n === "inherit" && "colorInherit", e && "disableElevation", t && "fullWidth"],
    label: ["label"],
    startIcon: ["startIcon", `iconSize${b(i)}`],
    endIcon: ["endIcon", `iconSize${b(i)}`]
  }, d = A(p, so, s);
  return u({}, s, d);
}, J = (o) => u({}, o.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, o.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, o.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), go = M(oo, {
  shouldForwardProp: (o) => no(o) || o === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (o, n) => {
    const {
      ownerState: e
    } = o;
    return [n.root, n[e.variant], n[`${e.variant}${b(e.color)}`], n[`size${b(e.size)}`], n[`${e.variant}Size${b(e.size)}`], e.color === "inherit" && n.colorInherit, e.disableElevation && n.disableElevation, e.fullWidth && n.fullWidth];
  }
})(({
  theme: o,
  ownerState: n
}) => {
  var e, t;
  const i = o.palette.mode === "light" ? o.palette.grey[300] : o.palette.grey[800], a = o.palette.mode === "light" ? o.palette.grey.A100 : o.palette.grey[700];
  return u({}, o.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (o.vars || o).shape.borderRadius,
    transition: o.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: o.transitions.duration.short
    }),
    "&:hover": u({
      textDecoration: "none",
      backgroundColor: o.vars ? `rgba(${o.vars.palette.text.primaryChannel} / ${o.vars.palette.action.hoverOpacity})` : E(o.palette.text.primary, o.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, n.variant === "text" && n.color !== "inherit" && {
      backgroundColor: o.vars ? `rgba(${o.vars.palette[n.color].mainChannel} / ${o.vars.palette.action.hoverOpacity})` : E(o.palette[n.color].main, o.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, n.variant === "outlined" && n.color !== "inherit" && {
      border: `1px solid ${(o.vars || o).palette[n.color].main}`,
      backgroundColor: o.vars ? `rgba(${o.vars.palette[n.color].mainChannel} / ${o.vars.palette.action.hoverOpacity})` : E(o.palette[n.color].main, o.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, n.variant === "contained" && {
      backgroundColor: o.vars ? o.vars.palette.Button.inheritContainedHoverBg : a,
      boxShadow: (o.vars || o).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (o.vars || o).shadows[2],
        backgroundColor: (o.vars || o).palette.grey[300]
      }
    }, n.variant === "contained" && n.color !== "inherit" && {
      backgroundColor: (o.vars || o).palette[n.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (o.vars || o).palette[n.color].main
      }
    }),
    "&:active": u({}, n.variant === "contained" && {
      boxShadow: (o.vars || o).shadows[8]
    }),
    [`&.${W.focusVisible}`]: u({}, n.variant === "contained" && {
      boxShadow: (o.vars || o).shadows[6]
    }),
    [`&.${W.disabled}`]: u({
      color: (o.vars || o).palette.action.disabled
    }, n.variant === "outlined" && {
      border: `1px solid ${(o.vars || o).palette.action.disabledBackground}`
    }, n.variant === "contained" && {
      color: (o.vars || o).palette.action.disabled,
      boxShadow: (o.vars || o).shadows[0],
      backgroundColor: (o.vars || o).palette.action.disabledBackground
    })
  }, n.variant === "text" && {
    padding: "6px 8px"
  }, n.variant === "text" && n.color !== "inherit" && {
    color: (o.vars || o).palette[n.color].main
  }, n.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, n.variant === "outlined" && n.color !== "inherit" && {
    color: (o.vars || o).palette[n.color].main,
    border: o.vars ? `1px solid rgba(${o.vars.palette[n.color].mainChannel} / 0.5)` : `1px solid ${E(o.palette[n.color].main, 0.5)}`
  }, n.variant === "contained" && {
    color: o.vars ? (
      // this is safe because grey does not change between default light/dark mode
      o.vars.palette.text.primary
    ) : (e = (t = o.palette).getContrastText) == null ? void 0 : e.call(t, o.palette.grey[300]),
    backgroundColor: o.vars ? o.vars.palette.Button.inheritContainedBg : i,
    boxShadow: (o.vars || o).shadows[2]
  }, n.variant === "contained" && n.color !== "inherit" && {
    color: (o.vars || o).palette[n.color].contrastText,
    backgroundColor: (o.vars || o).palette[n.color].main
  }, n.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, n.size === "small" && n.variant === "text" && {
    padding: "4px 5px",
    fontSize: o.typography.pxToRem(13)
  }, n.size === "large" && n.variant === "text" && {
    padding: "8px 11px",
    fontSize: o.typography.pxToRem(15)
  }, n.size === "small" && n.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: o.typography.pxToRem(13)
  }, n.size === "large" && n.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: o.typography.pxToRem(15)
  }, n.size === "small" && n.variant === "contained" && {
    padding: "4px 10px",
    fontSize: o.typography.pxToRem(13)
  }, n.size === "large" && n.variant === "contained" && {
    padding: "8px 22px",
    fontSize: o.typography.pxToRem(15)
  }, n.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: o
}) => o.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${W.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${W.disabled}`]: {
    boxShadow: "none"
  }
}), bo = M("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (o, n) => {
    const {
      ownerState: e
    } = o;
    return [n.startIcon, n[`iconSize${b(e.size)}`]];
  }
})(({
  ownerState: o
}) => u({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, o.size === "small" && {
  marginLeft: -2
}, J(o))), vo = M("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (o, n) => {
    const {
      ownerState: e
    } = o;
    return [n.endIcon, n[`iconSize${b(e.size)}`]];
  }
})(({
  ownerState: o
}) => u({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, o.size === "small" && {
  marginRight: -2
}, J(o))), Q = /* @__PURE__ */ m.forwardRef(function(n, e) {
  const t = m.useContext(lo), i = m.useContext(po), a = ro(t, n), s = q({
    props: a,
    name: "MuiButton"
  }), {
    children: p,
    color: d = "primary",
    component: l = "button",
    className: c,
    disabled: f = !1,
    disableElevation: v = !1,
    disableFocusRipple: g = !1,
    endIcon: $,
    focusVisibleClassName: V,
    fullWidth: P = !1,
    size: O = "medium",
    startIcon: S,
    type: T,
    variant: j = "text"
  } = s, k = K(s, uo), y = u({}, s, {
    color: d,
    component: l,
    disabled: f,
    disableElevation: v,
    disableFocusRipple: g,
    fullWidth: P,
    size: O,
    type: T,
    variant: j
  }), x = fo(y), I = S && /* @__PURE__ */ R(bo, {
    className: x.startIcon,
    ownerState: y,
    children: S
  }), w = $ && /* @__PURE__ */ R(vo, {
    className: x.endIcon,
    ownerState: y,
    children: $
  }), z = i || "";
  return /* @__PURE__ */ to(go, u({
    ownerState: y,
    className: _(t.className, x.root, c, z),
    component: l,
    disabled: f,
    focusRipple: !g,
    focusVisibleClassName: _(x.focusVisible, V),
    ref: e,
    type: T
  }, k, {
    classes: x,
    children: [I, p, w]
  }));
});
process.env.NODE_ENV !== "production" && (Q.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * Element placed after the children.
   */
  endIcon: r.node,
  /**
   * @ignore
   */
  focusVisibleClassName: r.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: r.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium", "large"]), r.string]),
  /**
   * Element placed before the children.
   */
  startIcon: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @ignore
   */
  type: r.oneOfType([r.oneOf(["button", "reset", "submit"]), r.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: r.oneOfType([r.oneOf(["contained", "outlined", "text"]), r.string])
});
const Go = Q, X = /* @__PURE__ */ m.createContext();
process.env.NODE_ENV !== "production" && (X.displayName = "GridContext");
const D = X;
function xo(o) {
  return F("MuiGrid", o);
}
const mo = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], yo = ["column-reverse", "column", "row-reverse", "row"], $o = ["nowrap", "wrap-reverse", "wrap"], h = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], N = U("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...mo.map((o) => `spacing-xs-${o}`),
  // direction values
  ...yo.map((o) => `direction-xs-${o}`),
  // wrap values
  ...$o.map((o) => `wrap-xs-${o}`),
  // grid sizes for all breakpoints
  ...h.map((o) => `grid-xs-${o}`),
  ...h.map((o) => `grid-sm-${o}`),
  ...h.map((o) => `grid-md-${o}`),
  ...h.map((o) => `grid-lg-${o}`),
  ...h.map((o) => `grid-xl-${o}`)
]), zo = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "rowSpacing", "spacing", "wrap", "zeroMinWidth"];
function C(o) {
  const n = parseFloat(o);
  return `${n}${String(o).replace(String(n), "") || "px"}`;
}
function Co({
  theme: o,
  ownerState: n
}) {
  let e;
  return o.breakpoints.keys.reduce((t, i) => {
    let a = {};
    if (n[i] && (e = n[i]), !e)
      return t;
    if (e === !0)
      a = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (e === "auto")
      a = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const s = G({
        values: n.columns,
        breakpoints: o.breakpoints.values
      }), p = typeof s == "object" ? s[i] : s;
      if (p == null)
        return t;
      const d = `${Math.round(e / p * 1e8) / 1e6}%`;
      let l = {};
      if (n.container && n.item && n.columnSpacing !== 0) {
        const c = o.spacing(n.columnSpacing);
        if (c !== "0px") {
          const f = `calc(${d} + ${C(c)})`;
          l = {
            flexBasis: f,
            maxWidth: f
          };
        }
      }
      a = u({
        flexBasis: d,
        flexGrow: 0,
        maxWidth: d
      }, l);
    }
    return o.breakpoints.values[i] === 0 ? Object.assign(t, a) : t[o.breakpoints.up(i)] = a, t;
  }, {});
}
function Oo({
  theme: o,
  ownerState: n
}) {
  const e = G({
    values: n.direction,
    breakpoints: o.breakpoints.values
  });
  return L({
    theme: o
  }, e, (t) => {
    const i = {
      flexDirection: t
    };
    return t.indexOf("column") === 0 && (i[`& > .${N.item}`] = {
      maxWidth: "none"
    }), i;
  });
}
function Y({
  breakpoints: o,
  values: n
}) {
  let e = "";
  Object.keys(n).forEach((i) => {
    e === "" && n[i] !== 0 && (e = i);
  });
  const t = Object.keys(o).sort((i, a) => o[i] - o[a]);
  return t.slice(0, t.indexOf(e));
}
function ho({
  theme: o,
  ownerState: n
}) {
  const {
    container: e,
    rowSpacing: t
  } = n;
  let i = {};
  if (e && t !== 0) {
    const a = G({
      values: t,
      breakpoints: o.breakpoints.values
    });
    let s;
    typeof a == "object" && (s = Y({
      breakpoints: o.breakpoints.values,
      values: a
    })), i = L({
      theme: o
    }, a, (p, d) => {
      var l;
      const c = o.spacing(p);
      return c !== "0px" ? {
        marginTop: `-${C(c)}`,
        [`& > .${N.item}`]: {
          paddingTop: C(c)
        }
      } : (l = s) != null && l.includes(d) ? {} : {
        marginTop: 0,
        [`& > .${N.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return i;
}
function Bo({
  theme: o,
  ownerState: n
}) {
  const {
    container: e,
    columnSpacing: t
  } = n;
  let i = {};
  if (e && t !== 0) {
    const a = G({
      values: t,
      breakpoints: o.breakpoints.values
    });
    let s;
    typeof a == "object" && (s = Y({
      breakpoints: o.breakpoints.values,
      values: a
    })), i = L({
      theme: o
    }, a, (p, d) => {
      var l;
      const c = o.spacing(p);
      return c !== "0px" ? {
        width: `calc(100% + ${C(c)})`,
        marginLeft: `-${C(c)}`,
        [`& > .${N.item}`]: {
          paddingLeft: C(c)
        }
      } : (l = s) != null && l.includes(d) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${N.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return i;
}
function No(o, n, e = {}) {
  if (!o || o <= 0)
    return [];
  if (typeof o == "string" && !Number.isNaN(Number(o)) || typeof o == "number")
    return [e[`spacing-xs-${String(o)}`]];
  const t = [];
  return n.forEach((i) => {
    const a = o[i];
    Number(a) > 0 && t.push(e[`spacing-${i}-${String(a)}`]);
  }), t;
}
const So = M("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (o, n) => {
    const {
      ownerState: e
    } = o, {
      container: t,
      direction: i,
      item: a,
      spacing: s,
      wrap: p,
      zeroMinWidth: d,
      breakpoints: l
    } = e;
    let c = [];
    t && (c = No(s, l, n));
    const f = [];
    return l.forEach((v) => {
      const g = e[v];
      g && f.push(n[`grid-${v}-${String(g)}`]);
    }), [n.root, t && n.container, a && n.item, d && n.zeroMinWidth, ...c, i !== "row" && n[`direction-xs-${String(i)}`], p !== "wrap" && n[`wrap-xs-${String(p)}`], ...f];
  }
})(({
  ownerState: o
}) => u({
  boxSizing: "border-box"
}, o.container && {
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
}, o.item && {
  margin: 0
  // For instance, it's useful when used with a `figure` element.
}, o.zeroMinWidth && {
  minWidth: 0
}, o.wrap !== "wrap" && {
  flexWrap: o.wrap
}), Oo, ho, Bo, Co);
function To(o, n) {
  if (!o || o <= 0)
    return [];
  if (typeof o == "string" && !Number.isNaN(Number(o)) || typeof o == "number")
    return [`spacing-xs-${String(o)}`];
  const e = [];
  return n.forEach((t) => {
    const i = o[t];
    if (Number(i) > 0) {
      const a = `spacing-${t}-${String(i)}`;
      e.push(a);
    }
  }), e;
}
const ko = (o) => {
  const {
    classes: n,
    container: e,
    direction: t,
    item: i,
    spacing: a,
    wrap: s,
    zeroMinWidth: p,
    breakpoints: d
  } = o;
  let l = [];
  e && (l = To(a, d));
  const c = [];
  d.forEach((v) => {
    const g = o[v];
    g && c.push(`grid-${v}-${String(g)}`);
  });
  const f = {
    root: ["root", e && "container", i && "item", p && "zeroMinWidth", ...l, t !== "row" && `direction-xs-${String(t)}`, s !== "wrap" && `wrap-xs-${String(s)}`, ...c]
  };
  return A(f, xo, n);
}, B = /* @__PURE__ */ m.forwardRef(function(n, e) {
  const t = q({
    props: n,
    name: "MuiGrid"
  }), {
    breakpoints: i
  } = eo(), a = io(t), {
    className: s,
    columns: p,
    columnSpacing: d,
    component: l = "div",
    container: c = !1,
    direction: f = "row",
    item: v = !1,
    rowSpacing: g,
    spacing: $ = 0,
    wrap: V = "wrap",
    zeroMinWidth: P = !1
  } = a, O = K(a, zo), S = g || $, T = d || $, j = m.useContext(D), k = c ? p || 12 : j, y = {}, x = u({}, O);
  i.keys.forEach((z) => {
    O[z] != null && (y[z] = O[z], delete x[z]);
  });
  const I = u({}, a, {
    columns: k,
    container: c,
    direction: f,
    item: v,
    rowSpacing: S,
    columnSpacing: T,
    wrap: V,
    zeroMinWidth: P,
    spacing: $
  }, y, {
    breakpoints: i.keys
  }), w = ko(I);
  return /* @__PURE__ */ R(D.Provider, {
    value: k,
    children: /* @__PURE__ */ R(So, u({
      ownerState: I,
      className: _(w.root, s),
      as: l,
      ref: e
    }, x))
  });
});
process.env.NODE_ENV !== "production" && (B.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: r.oneOfType([r.arrayOf(r.number), r.number, r.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: r.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: r.oneOfType([r.oneOf(["column-reverse", "column", "row-reverse", "row"]), r.arrayOf(r.oneOf(["column-reverse", "column", "row-reverse", "row"])), r.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: r.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: r.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: r.bool
});
if (process.env.NODE_ENV !== "production") {
  const o = ao("Grid", B);
  B["propTypes"] = u({}, B.propTypes, {
    direction: o("container"),
    lg: o("item"),
    md: o("item"),
    sm: o("item"),
    spacing: o("container"),
    wrap: o("container"),
    xs: o("item"),
    zeroMinWidth: o("item")
  });
}
const Mo = B;
export {
  lo as B,
  Mo as G,
  Go as M,
  po as a
};
//# sourceMappingURL=Grid-242d36e3.js.map
